'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = require('../utils');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * Created by @玩家 on 2017/2/7.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


/**
 * normal fetcher
 * @param url
 * @param options
 */
exports['default'] = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(req) {
    var headers, method, url, serializeData, mode, credentials, cache, timeout, fetchInit, options;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = req.headers, method = req.method, url = req.url, serializeData = req.serializeData, mode = req.mode, credentials = req.credentials, cache = req.cache, timeout = req.timeout, fetchInit = req.fetchInit;
            options = _extends({ headers: headers, method: method, mode: mode, credentials: credentials, cache: cache }, fetchInit);


            if (method !== 'GET') {
              options.body = serializeData;
            }

            _context.next = 5;
            return Promise.race([fetch(url, options), (0, _utils.delay)(timeout)]);

          case 5:
            return _context.abrupt('return', _context.sent);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function normalFetcher(_x) {
    return _ref.apply(this, arguments);
  }

  return normalFetcher;
}();

module.exports = exports['default'];